/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneTeamSettingsBodyVersionMin = 0;
export const phoneTeamSettingsBodyVersionMax = 9007199254740991;

export const phoneTeamSettingsBodyInboundNumberOneRegExp = new RegExp('^\\+[1-9][0-9]{1,14}$');
export const phoneTeamSettingsBodyMessagesInboundGreetingTwoTextMax = 400;

export const phoneTeamSettingsBodyMessagesInboundGreetingThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsBodyMessagesClientCodePromptTwoTextMax = 80;

export const phoneTeamSettingsBodyMessagesClientCodePromptThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsBodyMessagesBeforeTransferTwoTextMax = 80;

export const phoneTeamSettingsBodyMessagesBeforeTransferThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneTeamSettingsBodyMessagesVoicemailPromptTwoTextMax = 200;

export const phoneTeamSettingsBodyMessagesVoicemailPromptThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const PhoneTeamSettingsBody = zod.object({
  version: zod.int().min(phoneTeamSettingsBodyVersionMin).max(phoneTeamSettingsBodyVersionMax),
  inboundNumber: zod.union([
    zod.string().regex(phoneTeamSettingsBodyInboundNumberOneRegExp),
    zod.null(),
  ]),
  codeRequired: zod.boolean(),
  messages: zod.object({
    inboundGreeting: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(phoneTeamSettingsBodyMessagesInboundGreetingTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod.uuid().regex(phoneTeamSettingsBodyMessagesInboundGreetingThreeAssetIdRegExp),
      }),
    ]),
    clientCodePrompt: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(phoneTeamSettingsBodyMessagesClientCodePromptTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod.uuid().regex(phoneTeamSettingsBodyMessagesClientCodePromptThreeAssetIdRegExp),
      }),
    ]),
    beforeTransfer: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(phoneTeamSettingsBodyMessagesBeforeTransferTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod.uuid().regex(phoneTeamSettingsBodyMessagesBeforeTransferThreeAssetIdRegExp),
      }),
    ]),
    voicemailPrompt: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(phoneTeamSettingsBodyMessagesVoicemailPromptTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod.uuid().regex(phoneTeamSettingsBodyMessagesVoicemailPromptThreeAssetIdRegExp),
      }),
    ]),
  }),
});

export type PhoneTeamSettingsBody = zod.input<typeof PhoneTeamSettingsBody>;
export type PhoneTeamSettingsBodyOutput = zod.output<typeof PhoneTeamSettingsBody>;
